import React, { useState, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid';
import { Tooltip } from "bootstrap";
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AfficheReservationMensuel } from '../../Api/RestaurantApi/ResaMensuelApi';
import './css/resaHebdomadaire.css';

const ResaHebdomadaire = () => {

    const [data, setData] = useState();
    const [event, setEvent] = useState([]);
    const [loading, setLoading] = useState(false);


    const restaurant = useSelector((state) => state.restaurant);

    let tooltipInstance = null;

    let location = useLocation();
    let navigate = useNavigate();



    function renderEventContent(eventInfo) {
        if (eventInfo.event.title === "reservation") {
            return (
                <div style={{ backgroundColor: eventInfo.event.backgroundColor, color: eventInfo.event.textColor, display: 'flex' }}>
                    <div>Résa <i> {eventInfo.event.extendedProps.resa}</i></div>-
                    <div className=''>Couv <i> {eventInfo.event.extendedProps.couverte}</i></div>
                </div>
            )
        } else if (eventInfo.event.title === "fermeture") {
            return (
                <div style={{ backgroundColor: eventInfo.event.backgroundColor, color: eventInfo.event.textColor }}>
                    <div><i> {eventInfo.event.title}</i></div>
                </div>
            )
        }
        // } else if (eventInfo.event.title === "Fermeture P.") {
        //     return (
        //         <div style={{ backgroundColor: eventInfo.event.backgroundColor, color: eventInfo.event.textColor}}>
        //             <div><i> {eventInfo.event.title}</i></div>
        //         </div>
        //     )
        // }

    }



    const formatSingle = (date) => {
        if (parseInt(date) < 10) {
            return "0" + date;
        } else {
            return date;
        }
    }

    useEffect(() => {
        AfficheResaResto();
    }, []);

    const AfficheResaResto = () => {
        setLoading(true);
        AfficheReservationMensuel(restaurant.id)
            .then(function (response) {
                console.log("data =>", response.data.donner);
                response.data.donner.forEach((element) => {
                    let date = new Date(element.datePrise).getFullYear() + "-" + formatSingle(parseInt(new Date(element.datePrise).getMonth() + 1)) + "-" + formatSingle(new Date(element.datePrise).getDate()) + "T" + formatSingle(new Date(element.heurePrise).getUTCHours()) + ":" + formatSingle(new Date(element.heurePrise).getMinutes()) + ":" + "00";
                    let TotalRes = response.data.donner.filter((el) => el.datePrise === element.datePrise);
                    let TotalPersonne = TotalRes.reduce((prev, current) => prev + parseInt(current.nombrePersonne), 0);

                    const existeDate = event.find((el) => el.start === date);
                    if (existeDate) {
                        console.log("Modification");
                    } else {
                        setEvent((prev) => [...prev, { title: 'reservation', start: date, resa: TotalRes.length, couverte: TotalPersonne, backgroundColor: 'blue', textColor: '#fff', display: 'background' }]);
                    }
                });

                restaurant.fermetureCongers.forEach((item) => {
                    setEvent((prev) => [...prev, { title: 'fermeture', start: new Date(item.du).getFullYear() + "-" + formatSingle(parseInt(new Date(item.du).getMonth() + 1)) + "-" + formatSingle(new Date(item.du).getDate()), end: new Date(item.au).getFullYear() + "-" + formatSingle(parseInt(new Date(item.au).getMonth() + 1)) + "-" + formatSingle(parseInt(new Date(item.au).getDate() + 1)), backgroundColor: 'grey', textColor: '#fff', display: 'background' }])
                });
                setData(response.data.donner);
            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(function () {
                setLoading(false);
            });
    };

    console.log("Les event sont =>", event);

    return (
        <div>
            <Helmet>
                <title>Réservation Hebdomadaire</title>
                <meta name='description' content='Restaurant réservation hebdomadaire .' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <div className='hebdomadaire'>
                <div className='container'>
                    <div className="bloc_hebdomadaire">
                        <div className='hebdo_titre'>
                            <div className='d-flex mt-2 titre'>
                                <i className='fa fa-calendar-o'></i> <h1>Etats de réservations – vision hebdomadaire</h1>
                            </div>
                            <div className='hebdo_renseignement'>
                                <p>Affichage de la répartition des réservations de la semaine, prenant en compte les créneaux de fermeture, vous permettant de visualiser rapidement votre activité et d’ajuster vos promotions, organisation et prises de réservation en direct.
                                </p>
                                <p><span className='avertissement'>Attention : </span>il s’agit des créneaux  de réservation (début de la prestation) et non du temps de présence de vos clients à table !
                                </p>
                            </div>
                        </div>
                        <div className='hebdo_content'>
                            <div className='d-flex justify-content-center'>
                                <div className='calendar'>
                                    <FullCalendar
                                        plugins={[dayGridPlugin, timeGridPlugin]}
                                        initialView="timeGridWeek"
                                        allDayText='Heure'
                                        height='1100px'
                                        firstDay='1'
                                        buttonText={{
                                            today: "Cette semaine"
                                        }}

                                        editable={true}
                                        slotLabelInterval='00:30:00'
                                        slotMinTime='06:00:00'
                                        slotMaxTime='24:00:00'
                                        slotLabelFormat={[
                                            {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                meridiem: false,
                                            },
                                        ]}
                                        eventContent={renderEventContent}
                                        headerToolbar={{
                                            left: 'prev,next',
                                            center: 'title',
                                            right: 'today'
                                        }}

                                        events={event}

                                        // events={event}
                                        // eventClick={(info) => {
                                        //     if (info.event.title === "reservation") {
                                        //         if (tooltipInstance) {
                                        //             tooltipInstance.dispose();
                                        //             tooltipInstance = null;
                                        //         }
                                        //         setData(info.event);

                                        //         navigate('/restaurant/creneau', { state: { title: info.event.title, donner: info.event.extendedProps } });
                                        //     }

                                        // }}
                                        eventMouseEnter={(info) => {
                                            if (info.event.title === "reservation") {
                                                var tooltipContent = '<div className="calendarTooltip" style="padding-left:10px; text-align: center;width:185px;height:35px;background:#126da2; border-radius: 8px; color: white;position:absolute;z-index:10001;"><div style=background:white;><div>' + info.event.start.toLocaleDateString() + '</div>Nbre de couvert ' + info.event.extendedProps.couverte + '</div> <div>Nbre de Réservation ' + info.event.extendedProps.resa + '</div></div>';
                                                tooltipInstance = new Tooltip(info.el, {
                                                    title: tooltipContent,
                                                    html: true,
                                                    placement: "bottom",
                                                    trigger: "hover",
                                                    container: "body"
                                                });

                                                tooltipInstance.show();
                                            }
                                        }}
                                        eventMouseLeave={() => {
                                            if (tooltipInstance) {
                                                tooltipInstance.dispose();
                                                tooltipInstance = null;
                                            }
                                        }}
                                        locale='fr'
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default ResaHebdomadaire